import { render, staticRenderFns } from "./saveCard.vue?vue&type=template&id=aed0e9f2&"
import script from "./saveCard.vue?vue&type=script&lang=js&"
export * from "./saveCard.vue?vue&type=script&lang=js&"
import style0 from "./saveCard.vue?vue&type=style&index=0&id=aed0e9f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports